import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts/BoosterNextFY-Regular.woff'
import './fonts/BoosterNextFY-Regular.woff2'



import './index.css';
import App from './App';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

